import styles from './FilterDropdown.module.css';

const FilterDropdown: React.FC = (props) => {
  return <div className={styles.dropdown} {...props} />;
};

export default FilterDropdown;
